import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ElectricMopedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"electric_moped"}/>
}
